<template>
  <el-main class="main">
    <div class="flex">
      <div class="listMD" ref="element">
        <div class="search flex">
          <div class="seaicon">
            <img src="../../assets/icon/搜索@3x.png" height="20" width="20" />
          </div>
          <el-input v-model="stutitle" @input="search" class="seasubfix">
          </el-input>
        </div>
        <div class="jstudent">
          <projectList
            class="preWrapper"
            :type="'not_interviewed'"
            :selectId.sync="selectId"
            ref="not_interviewed"
          />
          <projectList
            class="preWrapper"
            :type="'interviewed'"
            :selectId.sync="selectId"
            ref="interviewed"
            v-if="not_interviewed"
          />
          <div
            style="font-size: 16px;color: #656d78;padding-top: 1em;"
            v-if="selectId === 0"
          >
            未搜索到相关信息
          </div>
        </div>
      </div>
      <div class="neirong">
        <div class="jtitle">
          <h2 class="jtext">面试学员</h2>
        </div>
        <projectInfo :project="activeProject">
          <div slot="roles" class="rolesIcon">
            <el-tooltip effect="light" content="规划师" placement="top">
              <img src="../../assets/roles/icon/规划师.png" />
            </el-tooltip>
            <span>{{ activeProject.planner }}</span>
            <el-tooltip effect="light" content="客户经理" placement="top">
              <img src="../../assets/roles/icon/客户经理.png" />
            </el-tooltip>
            <span>{{ activeProject.amanager }}</span>
            <el-tooltip effect="light" content="渠道经理" placement="top">
              <img src="../../assets/roles/icon/渠道经理.png" />
            </el-tooltip>
            <span>{{ activeProject.cmanager }}</span>
          </div>
        </projectInfo>
      </div>
    </div>
  </el-main>
</template>

<script>
/* eslint-disable no-console */
import axios from '../axios'
import projectList from '../pub/projectList'
import projectInfo from '../pub/projectInfo'
import informationButton from '../pub/buttons/informationButton'
import newProject from '../pub/studentDialog/newProject'
import editProject from '../pub/studentDialog/editProject'
import StartDialog, { StartDialogMixin } from '../pub/StartDialog'
import { EndDialogMixin } from '../pub/EndDialog.vue'
import _ from 'lodash'
export default {
  name: 'Einterview',
  mixins: [StartDialogMixin, EndDialogMixin],
  components: {
    projectList,
    projectInfo,
    informationButton,
    newProject,
    editProject,
    StartDialog
  },
  data () {
    return {
      smes: {
        name: '',
        school: '',
        cellphone: '',
        email: '',
        direction: '',
        sex: ''
      },
      stutitle: '',
      options: ['学员', '导师'],
      role: '学员',
      teacher: '',
      project_type: '',
      s_name: '',
      t_name: '',
      pid: 0,
      activeProject: {},
      selectId: 0,
      not_interviewed: false
    }
  },
  watch: {
    selectId (newVal, oldVal) {
      if (newVal !== oldVal) this.getProject()
    }
  },
  methods: {
    search: _.debounce(function () {
      if (this.role === '学员') this.s_name = this.stutitle
      else if (this.role === '导师') this.t_name = this.stutitle
      this.$refs.not_interviewed.getList(this.s_name, this.t_name)
      this.$refs.interviewed.getList(this.s_name, this.t_name)
    }, 500),
    rolechange () {
      this.s_name = ''
      this.t_name = ''
      this.stutitle = ''
      this.search()
    },
    getProject () {
      axios
        .get(`/${this.$store.state.roleApi}/project/${this.selectId}/`)
        .then(response => {
          this.teacher = response.data.teacher
          this.project_type = response.data.project.project_type
          this.pid = response.data.project.id
          this.smes = response.data.student
          this.activeProject = response.data.project
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
